export default __webpack_public_path__ + "static/media/img-home.5c8f64f7.png";